import colors from 'vuetify/lib/util/colors'

export default {
  options: {
    customProperties: true
  },
  themes: {
    light: {
      primary: colors.blueGrey.base,
      secondary: colors.blueGrey.lighten1,
      accent: colors.deepOrange.base,
      error: colors.red.base,
      warning: colors.yellow.base,
      info: colors.blue.base,
      success: colors.green.base
    },
    dark: {
      primary: colors.blueGrey.base,
      secondary: colors.blueGrey.lighten1,
      accent: colors.deepOrange.base,
      error: colors.red.base,
      warning: colors.yellow.base,
      info: colors.blue.base,
      success: colors.green.base
    }
  }
}
